module.exports = __webpack_public_path__ + "static/img/Fl-Pharaoh.6a0afe4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Fl-Pharaoh.jpg
// module id = vuNQ
// module chunks = 1